import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from './local-storage.service';
import { HttpService } from './http.service';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';
import { ServiceResponseModel } from '../models/general/service-response.model';
import { LoginResponseModel } from '../models/security/auth/login-response.model';
import { LoginWithSSORequestModel } from '../models/security/auth/login-with.sso.request.model';
import { KisiModel } from '../models/security/user/kisi.model';
import { PageModel } from '../models/security/page/page.model';
import { MenuModel } from '../models/security/menu/menu.model';
import { environment } from 'src/environments/environment';
import { kodEnums, KOD_ENUMS_KEYS } from '../config/kod-enums.config';
import { GUNDEM_ROL_IDLERI } from '../config/role-enums.config';
import { KullaniciTipi } from '../config/tema.config';
import { RolSimulasyonBaslatRequestModel, RolSimulasyonDurumModel } from '../models/security/simulasyon/rol-simulasyon.model';

// import { UserService } from '../_services/userService/user.service';
// import { AuthData, LoginRequest } from '../_services/userService/user.model';
@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {
  loginResponse: LoginResponseModel = LocalStorageService.getDecodedLocalStorageObject() as LoginResponseModel;
  // public fields
  currentUser$: Observable<LoginResponseModel>;
  isLoading$: Observable<boolean>;
  currentUserSubject: BehaviorSubject<LoginResponseModel>;
  // currentUserBase64ImageSubject: BehaviorSubject<string>;
  isLoadingSubject: BehaviorSubject<boolean>;

  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  get currentUserValue(): LoginResponseModel {
    return this.currentUserSubject.value;
  }
  set currentUserValue(user: LoginResponseModel) {
    this.currentUserSubject.next(user);
  }

  get currentUserBase64ImageValue(): string {
    return localStorage.getItem("base64Foto")!;
  }
  // set currentUserBase64ImageValue(foto: string) {
  //   this.currentUserBase64ImageSubject.next(foto);
  // }
  constructor(
    private router: Router,
    private readonly httpService: HttpService,
    // private readonly globals : Globals
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.currentUserSubject = new BehaviorSubject<LoginResponseModel>(new LoginResponseModel);
    this.currentUser$ = this.currentUserSubject.asObservable();
    this.isLoading$ = this.isLoadingSubject.asObservable();
    const subscr = this.GetUserFromLocalStorage().subscribe();
    this.unsubscribe.push(subscr);
  }
  // GetSelectedOgrenci(): OgrenciDTO {
  //   return this.currentUserValue.userDto.userOgrenciDtoList.find(x => x.eid === this.currentUserValue.userDto.selectedOgrenciId)
  // }
  LoginWithToken(request :LoginWithSSORequestModel): Observable<LoginResponseModel> {
    this.isLoadingSubject.next(true);
    // let request = { token: token, loginName: loginName,yetkiAppCode:1930002 };
    return this.httpService.Post('Security/Auth/LoginWithToken', request).pipe(
      map((res: ServiceResponseModel) => {
        let respose = res.data as LoginResponseModel;


        if (respose?.kisiTokenDto?.isLogin) {

          this.currentUserSubject.next(respose);
          //Devamlı Öğrenci durumundaki kaydı üstte listelemek için.
          // var userData=res.data.userDto.userOgrenciDtoList.filter(x=>x.ogrenciStatuKodDto.id==1070013)[0];

          // respose.userDto.selectedOgrenciId = userData!=undefined?userData.eid:res.data.userDto.userOgrenciDtoList[0].eid;
          // respose.userDto.selectedOgrenci = userData!=undefined?userData.eid:res.data.userDto.userOgrenciDtoList[0];
          // respose.menuListDto = respose.userDto.userOgrenciDtoList.filter(x => x.eid == respose.userDto.selectedOgrenciId)[0].menuListDto;;
          // respose.pageListDto =respose.userDto.userOgrenciDtoList.filter(x => x.eid == respose.userDto.selectedOgrenciId)[0].pageListDto;;
          // respose.userCustomPermissions =respose.userDto.userOgrenciDtoList.filter(x => x.eid == respose.userDto.selectedOgrenciId)[0].userCustomPermissionDto;
          const result = LocalStorageService.setEncodedLocalStorageItem(respose);
        } else {
          `${environment.loginUrl}`;

          return respose;
        }
        return respose;
      }),
      catchError((err) => {
        console.error('err', err);
        return of(new LoginResponseModel);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  // ---------------------------------------------------------------------------
  // Rol Simülasyonu
  // Süper admin, seçtiği rolün/kullanıcının yetkileriyle uygulamayı gezer.
  // Backend tam bir LoginResponseModel döner; login akışının aynısı uygulanır.
  // ---------------------------------------------------------------------------

  /** Aktif oturumda simülasyon var mı? (Sayfa yenilendikten sonra bandı doğrulamak için.) */
  SimulasyonDurum(): Observable<RolSimulasyonDurumModel> {
    return this.httpService.Post('Security/RolSimulasyon/Durum', {}).pipe(
      map((res: ServiceResponseModel) => res.data as RolSimulasyonDurumModel),
      catchError((err) => {
        console.error('err', err);
        return of(new RolSimulasyonDurumModel());
      })
    );
  }

  /**
   * Simülasyonu başlatır. Başarılıysa yeni oturumu localStorage'a yazar ve
   * TAM SAYFA YENİLEMESİ ile hedef rotaya gider.
   *
   * Sayfa yenilemesi zorunlu: sidebar (_metronic/.../sidebar-menu.component.ts) menuListDto'yu
   * constructor'da okuyor, currentUserSubject'e abone değil. _metronic klasörü değiştirilemez,
   * dolayısıyla menülerin yeni role göre kurulmasının tek yolu reload. Zaten "yeniden login
   * olmuş gibi" davranışı da birebir bu.
   */
  SimulasyonBaslat(request: RolSimulasyonBaslatRequestModel): Observable<LoginResponseModel> {
    this.isLoadingSubject.next(true);
    return this.httpService.Post('Security/RolSimulasyon/Baslat', request).pipe(
      map((res: ServiceResponseModel) => {
        const response = res.data as LoginResponseModel;

        if (response?.kisiTokenDto?.isLogin) {
          this.currentUserSubject.next(response);
          LocalStorageService.setEncodedLocalStorageItem(response);
        }

        return response;
      }),
      catchError((err) => {
        console.error('err', err);
        return of(new LoginResponseModel);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  /** Simülasyonu bitirir ve süper adminin kendi oturumunu geri yükler. */
  SimulasyonBitir(): Observable<LoginResponseModel> {
    this.isLoadingSubject.next(true);
    return this.httpService.Post('Security/RolSimulasyon/Bitir', {}).pipe(
      map((res: ServiceResponseModel) => {
        const response = res.data as LoginResponseModel;

        if (response?.kisiTokenDto?.isLogin) {
          this.currentUserSubject.next(response);
          LocalStorageService.setEncodedLocalStorageItem(response);
        }

        return response;
      }),
      catchError((err) => {
        console.error('err', err);
        return of(new LoginResponseModel);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  /** Uyarı bandı bu iki getter'ı okur. */
  get isSimulasyonAktif(): boolean {
    return this.currentUserValue?.kisiTokenDto?.isSimulasyon === true;
  }

  get simulasyonAciklama(): string {
    return this.currentUserValue?.kisiTokenDto?.simulasyonAciklama ?? '';
  }

  /** Simülasyon başlatan/bitiren akışın ortak sonu: oturumu tazelemek için tam sayfa yenileme. */
  SimulasyonSonrasiYenile(hedefRota: string): void {
    window.location.href = hedefRota;
  }

  /**
   * Yerel oturumdaki simülasyon işaretini temizler.
   *
   * Ne zaman gerekir: sunucu "aktif simülasyon yok" derken localStorage hâlâ simülasyon
   * açık sanıyorsa. Bu, simülasyon başlatıldıktan sonra akış yarıda kaldığında oluşuyordu
   * (ör. tarayıcı donması); uyarı bandı sonsuza dek ekranda kalıyor ve "Süper Admin'e dön"
   * her seferinde "Aktif bir simülasyon oturumu bulunmuyor" hatası veriyordu — yani
   * kullanıcının banttan kurtulmasının hiçbir yolu kalmıyordu.
   *
   * DİKKAT: Oturumu KAPATMAZ. Yalnız tutarsız kalan simülasyon alanlarını sıfırlar;
   * kullanıcı kendi yetkileriyle çalışmaya devam eder.
   */
  SimulasyonIsaretiniTemizle(): void {
    const oturum = this.currentUserValue;

    if (!oturum?.kisiTokenDto) {
      return;
    }

    oturum.kisiTokenDto.isSimulasyon = false;
    oturum.kisiTokenDto.simulasyonAciklama = '';

    this.currentUserSubject.next(oturum);
    LocalStorageService.setEncodedLocalStorageItem(oturum);
  }

  GetBase64Foto(request:KisiModel): Observable<string> {
    this.isLoadingSubject.next(true);
    return this.httpService.Post('Common/GetBase64Foto', request).pipe(
      map((res: ServiceResponseModel) => {
        let respose = res.data as string;
        //
        // this.currentUserBase64ImageSubject.next(respose);
          return respose;
      }),
      catchError((err) => {
        console.error('err', err);
        return of();
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }
  Logout() {
    this.navigateToLogin();
  }
  GetUserFromLocalStorage(): Observable<LoginResponseModel> {

    return new Observable<LoginResponseModel>(subscriber => {
      const auth = LocalStorageService.getDecodedLocalStorageObject() as LoginResponseModel;
      this.currentUserSubject.next(auth);
      subscriber.complete();
    });
  }

  RefreshMenuList(): Observable<MenuModel[]> {
    return this.httpService.Post('Security/Menu/GetMenuListForUser', null).pipe(
      map((res: ServiceResponseModel) => {
        const menus = (res?.data as MenuModel[]) ?? [];
        if (res?.messageType !== 'error' && this.currentUserValue?.kisiTokenDto?.isLogin) {
          const current = this.currentUserValue;
          current.menuListDto = menus;
          LocalStorageService.setEncodedLocalStorageItem(current);
          this.currentUserSubject.next(current);
        }
        return menus;
      }),
      catchError(() => of([] as MenuModel[]))
    );
  }

  checkPageAccess(currentUrl: string, pathData?: string): boolean {
    let isMatch = false;
    const userPageList = this.currentUserValue.pageListDto;
     if (userPageList !== undefined && userPageList !== null) {
       userPageList.forEach((element: PageModel) => {
         const link = element !== null ? element.routerLink : '';
         // Allow matching via route data.pathData when provided
         if ((pathData && pathData === link) || currentUrl === link) {
           isMatch = true;
           return isMatch;
         }
         else {
           let paramPosition = element.routerLink.indexOf("@") - 1;

           if (paramPosition !== -1) {
             let currentUrlWithParams = currentUrl.substring(0, paramPosition) + "/@"
             if ((pathData && pathData === link) || currentUrlWithParams === link) {
               isMatch = true;
               return isMatch;
             }
           }


         }
       }
       );
     }


    return isMatch;
  }
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
  checkWidgetAccess(widgetSelector: string): boolean {

    if (!this.currentUserValue.kisiTokenDto?.isLogin) { this.Logout(); return false; }
    const index = this.currentUserValue.widgetListDto.findIndex(x => x.selector == widgetSelector);
    return index > -1;
  }

  /**
   * Kullanıcının TÜM rolleri gündem rollerinden (Başkan/Sekreter/Görüntüleyici) mi oluşuyor?
   * SuperAdmin, Admin veya başka herhangi bir rolü de varsa false döner;
   * bu durumda mevcut varsayılan akış (/basvuru/liste) korunur.
   * Patent Detay gibi ortak sayfalarda hangi controller'ın (Admin/Gundem) çağrılacağını
   * belirlemek için de kullanılır.
   */
  isSadeceGundemRolu(): boolean {
    const roller = this.currentUserValue?.rolListDto ?? [];
    return roller.length > 0
      && roller.every(r => GUNDEM_ROL_IDLERI.includes(Number(r.rolId)));
  }

  /**
   * Navigates user to appropriate dashboard after successful login
   * Routes based on loginTip.id and user roles from current user
   */
  navigateAfterLogin(): void {
    const currentUser = this.currentUserValue;

    if (!currentUser?.kisiTokenDto?.isLogin) {
      console.warn('User not logged in, cannot navigate');
      return;
    }

    const destination = this.getDefaultRoute();
    console.log(`Navigating to: ${destination}`);
    this.router.navigate([destination]);
  }

  /**
   * Redirects user to appropriate SSO login page based on user type
   * Called on logout or session expiry
   */
  navigateToLogin(): void {
    const currentUser = this.currentUserValue;
    const loginTipId = currentUser?.kisiTokenDto?.loginTip?.id;

    // Clear localStorage before redirect
    LocalStorageService.delEncodedLocalStorageItem();

    // Determine which login URL based on user type
    if (loginTipId && loginTipId === kodEnums[KOD_ENUMS_KEYS.FIRMA_LOGIN_TIP]) {
      console.log('Redirecting to firma login');
      window.location.href = environment.loginUrlFirma;
    } else {
      console.log('Redirecting to normal user login');
      window.location.href = environment.loginUrl;
    }
  }

  /**
   * Kullanıcının hangi bağlamda çalıştığı. Hem varsayılan rotayı hem de görsel
   * temayı (sidebar + aksan rengi) belirler — ikisi TEK sınıflandırmadan türesin
   * diye buraya çıkarıldı. Daha önce bu mantık yalnız getDefaultRoute() içindeydi.
   *
   * - 'firma'  : firma girişiyle gelen kullanıcı (loginTip = firma)
   * - 'gundem' : TÜM rolleri gündem rollerinden oluşan kullanıcı
   *              (Başkan / Sekreter / Görüntüleyici). SuperAdmin, Admin veya
   *              başka herhangi bir rolü de varsa 'genel' döner.
   * - 'genel'  : diğer herkes (patent/başvuru akışı ve yönetim)
   *
   * Rol simülasyonunda currentUserValue komple simüle edilen kullanıcıyla
   * değiştiği için tip — ve dolayısıyla tema — otomatik olarak ona uyar.
   */
  getKullaniciTipi(): KullaniciTipi {
    const loginTipId = this.currentUserValue?.kisiTokenDto?.loginTip?.id;

    if (loginTipId && loginTipId === kodEnums[KOD_ENUMS_KEYS.FIRMA_LOGIN_TIP]) {
      return 'firma';
    }

    if (this.isSadeceGundemRolu()) {
      return 'gundem';
    }

    return 'genel';
  }

  /**
   * Kullanıcının login sonrası / erişim reddi sonrası gideceği varsayılan rota.
   * Sınıflandırma getKullaniciTipi() ile ortaktır.
   *
   * DİKKAT: Bu rotaya kullanıcının ERİŞEBİLECEĞİ garanti değildir. Yönlendirme yaparken
   * doğrudan bunu değil getGuvenliYonlendirmeRotasi()'nı kullanın; aksi halde erişilemeyen
   * bir rotaya yönlendirip guard'ı sonsuz döngüye sokarsınız.
   */
  getDefaultRoute(): string {
    switch (this.getKullaniciTipi()) {
      case 'firma':
        return '/firma/dashboard';
      case 'gundem':
        return '/gundem/liste';
      default:
        return '/basvuru/liste';
    }
  }

  /**
   * Kullanıcının GERÇEKTEN açabileceği bir rota döner; hiçbiri yoksa null.
   *
   * Neden gerekli: AuthGuard yetkisiz sayfada getDefaultRoute()'a yönlendiriyordu. O rotaya
   * da yetki yoksa guard yeniden çalışıp yeniden aynı yere yönlendiriyor, kendine dönen
   * sonsuz navigasyon oluşuyor ve tarayıcı kilitleniyordu (rol simülasyonunda firma rolüne
   * geçince tam olarak bu yaşanıyordu: yetkiler firma rolünden, iniş rotası ise loginTip'ten
   * hesaplandığı için ikisi ayrışıyor).
   *
   * Sıra:
   *  1. tipe uygun varsayılan rota,
   *  2. sidebar menüsündeki (görünen sırayla) ilk erişilebilir sayfa,
   *  3. menüde hiç uygun sayfa yoksa sayfa listesindeki ilk gerçek rota.
   * Hiç sayfa yoksa null döner ve çağıran taraf yönlendirmeyi DURDURUR.
   *
   * Menü, sayfa listesinden ÖNCE bakılır: sayfa listesi yetki zincirinden gelir ve menüden
   * kaldırılmış ama silinmemiş eski ekranları da içerir (ör. /patent-rapor; yerini
   * Rapor > İstatistik aldı). Kullanıcı menüde görmediği bir sayfaya indirilmemeli.
   */
  getGuvenliYonlendirmeRotasi(): string | null {
    const varsayilan = this.getDefaultRoute();
    if (this.checkPageAccess(varsayilan)) {
      return varsayilan;
    }

    const menudeki = this.menudekiRotalar(this.currentUserValue?.menuListDto ?? [])
      .find((rota) => this.checkPageAccess(rota));
    if (menudeki) {
      return menudeki;
    }

    const sayfalar = this.currentUserValue?.pageListDto ?? [];
    const acilabilir = sayfalar.find((s) => this.isInisRotasiOlabilir(s?.routerLink));
    return acilabilir ? acilabilir.routerLink : null;
  }

  /** Menü ağacındaki iniş rotası olabilecek sayfalar, sidebar'daki sırayla (derinlik öncelikli). */
  private menudekiRotalar(menuler: readonly MenuModel[]): string[] {
    return menuler.flatMap((menu) => [
      ...(this.isInisRotasiOlabilir(menu?.pageDto?.routerLink) ? [menu.pageDto.routerLink] : []),
      ...this.menudekiRotalar(menu?.subMenuListDto ?? []),
    ]);
  }

  /** Parametreli sayfalar (routerLink içinde "@" taşır) iniş rotası olamaz. */
  private isInisRotasiOlabilir(routerLink: string | null | undefined): routerLink is string {
    return !!routerLink && routerLink.indexOf('@') === -1;
  }
}
